var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgResearch28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75138 23.7486L8 23L5.75138 22.2457L5 20L4.24862 22.2457L2 23L4.24862 23.7486L5 26L5.75138 23.7486Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5012 3.50185L8 3.00247L6.5012 2.50309L6 1L5.4988 2.50309L4 3.00247L5.4988 3.50185L6 5L6.5012 3.50185Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1149 19.073C17.4285 19.0435 20.0926 16.3335 20.0653 13.0199C20.038 9.70626 17.3297 7.04393 14.0161 7.07338C10.7026 7.10282 8.03849 9.81289 8.06577 13.1265C8.09304 16.4401 10.8013 19.1024 14.1149 19.073ZM22.0652 13.0021C22.1016 17.4202 18.5495 21.0336 14.1314 21.0729C9.71327 21.1122 6.10221 17.5624 6.06585 13.1443C6.02948 8.72613 9.58158 5.1127 13.9997 5.07344C18.4178 5.03418 22.0288 8.58396 22.0652 13.0021Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2846 25.0265L18.643 19.2619L20.0724 17.8631L25.7139 23.6276L24.2846 25.0265Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0011 14.0029L18 13.0023L15.0011 12.0017L14 9L12.9989 12.0017L10 13.0023L12.9989 14.0029L14 17L15.0011 14.0029Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgResearch28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;